export enum Period {
  None = 0,
  // Hour = 1,
  // Day = 2,
  Week = 3,
  Month = 4
  // Year = 5
}

export enum PatternType {
  None = 0,
  DaysOfWeek = 1,
  DayOfMonth = 2,
  WeekOfMonth = 3
}

export enum DaysOfWeek {
  None = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 4,
  Thursday = 8,
  Friday = 16,
  Saturday = 32,
  Sunday = 64,
  Weekdays = (Monday | Tuesday | Wednesday | Thursday | Friday),
  Weekends = (Saturday | Sunday),
  Everyday = (Weekdays | Weekends)
}

export enum WeekOfMonth {
  None = 0,
  First = 1,
  Second = 2,
  Third = 3,
  Fourth = 4,
  Last = 5
}

export enum EndCondition {
  None = 0,
  OccurrenceCount = 1,
  Date = 2
}

export enum RecurrencyStatus {
  Planned = 1,
  Active = 2,
  Completed = 3,
  Cancelled = 4
}

export enum FormMode {
  Create,
  Edit
}



// WEBPACK FOOTER //
// ./src/app/shared/enums.ts